<template>
    <div class="relaciones">
        <div class="relacion-ver" v-if="Object.keys(relacion).length > 0">
            <div class="btn-toggle-details">
                <v-btn color="primary" icon @click="showDetails = !showDetails">
                    <v-icon center v-if="!showDetails">mdi-chevron-right</v-icon>
                    <v-icon center v-else>mdi-chevron-down</v-icon>
                </v-btn>
            </div>
            <div>
                <CardRelacion
                    :relacion="relacion"
                    :tratamientos="tratamientos"
                    @onEdit="onEdit(relacion)"
                />
            </div>
        </div>
        <v-list class="relacion-tratamientos" v-show="showDetails" elevation="1" shaped >
            <v-subheader v-if="!localSubTratamientosColor">{{ titleGroup || '¿Qué lunas necesitas?' }}</v-subheader>
            <draggable 
                v-model="localSubRelaciones" 
                v-bind="dragOptions"
                @change="onReorder"
                >
                <v-list-item
                    v-for="itemRelacion in localSubRelaciones"
                    :key="itemRelacion.id"
                    >
                    <v-list-item-action>
                        <v-icon small class="drag-handle" style="cursor:move">mdi-drag</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <TreeRelaciones
                            :relacion="itemRelacion"
                            :tratamientos="tratamientos"
                            :subRelaciones="itemRelacion.sub_relaciones"
                            :subRelacionesColor="itemRelacion?.tratamiento_color || [{asda:0}]"
                            :titleGroup="itemRelacion.page_titulo"
                            :isSunGlasses="isSunGlasses"
                        />
                    </v-list-item-content>
                </v-list-item>
            </draggable>

            <div v-if="showColores" class="tratamientos-color">
                <div>
                    <v-subheader>Tratamientos Color</v-subheader>
                </div>
                <div class="tratamientos-color-imgs" >
                    <v-img
                        v-for="itemRelacion in localSubTratamientosColor"
                        :key="itemRelacion.idtratamiento_color"
                        :src="assetAWS(itemRelacion.imagen)"
                        max-height="100"
                        max-width="100"
                        class="tratamiento-color-img"
                    />
                </div>
            </div>
            

            <v-list-item>
                <div class="relaciones">
                    <div class="relacion-ver">
                        <v-card>
                            <v-btn
                                small
                                text
                                color="primary"
                                @click="onAdd({
                                    code_parent: relacion.code || null,
                                    posicion: (subRelaciones.length || 0) +1
                                })"
                            >
                                +
                                Añadir Relación
                            </v-btn>
                        </v-card>
                    </div>
                </div>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import tratamientoRelacionService from '@/services/tratamientoRelacionService';
import CardRelacion from './CardRelacion.vue';
import draggable from 'vuedraggable'



export default {
    name: 'TreeRelaciones',
    components: {
        CardRelacion,
        draggable
    },
    props: {
        tratamientos: {
            type: Array,
            required: false,
            default: () => [],
        },
        relacion: {
            type: Object,
            default: () => ({}),
        },
        subRelaciones: {
            type: Array,
            required: false,
            default: () => [],
        },
        showSubRelaciones: {
            type: Boolean,
            default: false,
        },
        titleGroup: {
            type: String,
            default: '',
        },
        isSunGlasses: {
            type: Boolean,
            default: false,
        },
        subRelacionesColor: {
            type: Array,
            required: false,
            default: () => [],
        }
    },
    emits: [
    ],
    data() {
        return {
            showDetails: this.showSubRelaciones,
            localSubRelaciones: this.subRelaciones || [],
            localSubTratamientosColor: this.subRelacionesColor || [],
        }
    },
    watch: {
        subRelaciones: {
            handler(newVal) {
                this.localSubRelaciones = (newVal || []).slice().sort((a,b) => (a.posicion || 0) - (b.posicion || 0));
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        onAdd(data) {
            this.$store.dispatch('relaciones/addRelacion', data);
        },
        onEdit(data) {
            this.$store.dispatch('relaciones/editRelacion', data);
        },

        async onReorder() {            
            const listReordered = this.localSubRelaciones
                .map( (item, index) => {
                    return {
                        id: item.id,
                        posicion: index + 1
                    };
                });


            try {
                await tratamientoRelacionService.reorder(listReordered);
                this.$toasted.success('Relación reordenada correctamente.');

            } catch (error) {
                this.handleErrorApi(error);
            }
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
        showColores() {
            return this.isSunGlasses && this.localSubTratamientosColor.length > 0 && this.localSubRelaciones.length === 0;
        }
    }
};

</script>

<style scoped>
    /* .relaciones {
        display: flex;
        gap: 16px;
        width: 100%;
        justify-content: left;
        align-items: center;
    } */
    
    .relacion-ver {
        display: flex;
        align-items: center;
        gap: 8px;   
    }
    
    /* .btn-toggle-details{
        display: block;
        background: rgba(255, 255, 255, 0.1);
    } */
    
    .relacion-tratamientos {
        width: auto;
        margin-left: 1rem;
        padding-left: 1rem;
        /* background: rgba(255, 255, 255, 0.1); */
        background: rgba(112, 128, 144, 0.1);
    }

    .theme--light .relacion-tratamientos {
        background: rgba(112, 128, 144, 0.1);
    }

    .tratamientos-color {
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: .5rem;

    }

    .tratamientos-color-imgs{
        display: flex;
        gap: .25rem;
    }

</style>